<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Редактирование выборки</h3>
        <button type="button" class="close" @click="hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label>Название</label>
          <input type="text" class="form-control" v-model="sampleName">
        </div>
      </div>
      <div class="modal-footer d-flex">
        <btn-action
          class="btn btn-primary ml-auto"
          @click="save"
        >Сохранить</btn-action>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api'

  export default {
    props: ['id', 'name'],
    data () {
      return {
        sampleName: this.name,
      }
    },
    methods: {
      save () {
        const tmp = {name: this.sampleName}
        return api.put(`/samples/${this.id}`, tmp)
          .then((data) => {this.hide(tmp)})
      },
      hide (data) {
        this.$emit('hide', data)
      },
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/sample-modal-edit.vue